const priceComponent = (variantData) => { 
    let joinNowElements = document.querySelectorAll("#JoinNow .money-transfer-join-now");
    let priceVariantAElements = document.querySelectorAll("#PriceVariantA .money-transfer-price-component");
    let priceVariantBElements = document.querySelectorAll("#PriceVariantB .money-transfer-price-component2");
    let seasonalPriceVariantBElements = document.querySelector("#SeasonalPriceVariantB .money-transfer-price-component2");
    let moneyTransferElements = document.querySelectorAll('#HeroSP .money-transfer');
    let moneyTransferSecondElements = document.querySelectorAll('#HeroSP2 .money-transfer2');
    let joinNowId = document.getElementById("JoinNow");
    let priceVariantAId = document.getElementById("PriceVariantA");
    let priceVariantBId = document.getElementById("PriceVariantB");
    let priceVariantCalcWidgetEL = document.getElementById("summaryCalculator");
    let calcWidgetElements = priceVariantCalcWidgetEL?.querySelectorAll('.money-transfer-price-component2')
    let seasonalPriceVariantBId = document.getElementById("SeasonalPriceVariantB");
    let priceBenefits = document.getElementById("PriceComponentBenefits");
    let summaryBenefitsCalc = document.getElementById("PriceComponentBenefitsSummaryCalculator");
    const homePageExperience = CookieService.getCookie('homePageExperience') || (window.pageData.country.toUpperCase() === 'AU' ? 'smo' : 'registration')
    let priceVariantBElementsDisplay = priceVariantBElements && priceVariantBElements[0] && priceVariantBElements[0].getAttribute("data-display-status");
    const isR4Country = getR4Country();

    function homePriceComponent(data) {

        if(!data.variation){
            return;
        }
        let isenableHomePriceVariantA = (data.variation === 'priceVariantA') ? true : false;
        let isenableHomePriceVariantB = (data.variation === 'priceVariantB') ? true : false;
        let isEnablepriceVariantCalcWidgetEL = (data.variation === 'summaryCalculator') ? true : false;
        let isenableHomeJoinNow = (data.variation === 'joinnow') ? true : false;
        let isenableHomeseasonalPriceVariantB = (data.variation === 'seasonalPriceVariantB') ? true : false;

        let priceDocumentElements;
        if(data.variation === 'priceVariantB') {
            priceDocumentElements = priceVariantBId;
        } else if(data.variation === 'priceVariantA') { 
            priceDocumentElements = priceVariantAId;
        } else if(data.variation === 'joinnow') { 
            priceDocumentElements =  joinNowId;
        } else if(data.variation === 'seasonalPriceVariantB') { 
            priceDocumentElements =  seasonalPriceVariantBId;
        } else if(data.variation === 'summaryCalculator') {
            priceDocumentElements = priceVariantCalcWidgetEL
        }
        const currencySelectParentList = priceDocumentElements ? priceDocumentElements.querySelectorAll('.reciver-currency-select-dropdown'): null;
        const senderCurrency = currencySelectParentList ? currencySelectParentList[0].getAttribute('data-currency') : null;
        const senderCountry = currencySelectParentList ? currencySelectParentList[0].getAttribute('data-country'): null; 
        senderCurrency && senderCountry && document.addEventListener("priceCorridorReady", () => {

        // If Lean Registartion & Join Now Camp enable then verify Join Now Compoent 
        if (Boolean(joinNowElements)  || Boolean(calcWidgetElements) || Boolean(priceVariantAElements) || Boolean(priceVariantBElements) || Boolean(seasonalPriceVariantBElements)) {
            let userIdentity = CookieService.getCookie('userIdentity');
            if(!userIdentity){
                CookieService.setCookie('userIdentity', 'newCustomer',365,'/',true);
            }

            const userDetails = JSON.parse(sessionStorage.getItem('GatewayCustomer') || '{}');   
            // Prefetching Customer details for R3 and R4

            let userDetailsObj = {
                sender_firstName :  userDetails?.name?.firstName ??  userDetails?.name?.firstName ?? '',
                sender_lastName : userDetails?.name?.lastName  ?? userDetails?.name?.lastName ?? '',
                sender_middleName :  userDetails?.name?.middleName ?? userDetails?.name?.middleName ?? '',
                sender_emailAddress : userDetails?.email ?? userDetails?.email ?? '',
            }

            let isUserLogin = (userDetailsObj.sender_firstName && userDetailsObj.sender_lastName && userDetailsObj.sender_emailAddress) ? true : false;

            let hasFirstandLastname = (!userDetailsObj.sender_firstName && !userDetailsObj.sender_lastName && userDetailsObj.sender_emailAddress) ? true : false;

            if(hasFirstandLastname){
                isUserLogin = true;
                sessionStorage.setItem('FirstName', 'Hello');
                sessionStorage.setItem('LastName', 'User');            
            }  

            // CAPELLA-441
            if((userIdentity === 'registeredCustomer') || (userIdentity === 'existingCustomer')){
                isUserLogin = true;
            }            
           
            const currencySelectParentList = priceDocumentElements.querySelectorAll('.reciver-currency-select-dropdown'); 
            let isnewUX = checkBrandRefresh(currencySelectParentList[0])      
            const searchInput =  priceDocumentElements.querySelectorAll('.wuds-dropdown__search__box');
            let iconSearchClass = (isnewUX) ? '.wuds-dropdown__search__cancel__icon' : '.wuds-dropdown_search_currency_cancel';
            let liclass = (isnewUX) ? '.wuds-dropdown__search__list .wuds-dropdown__items' :  '.wuds-dropdown__search__list .wuds-dropdown__item';
            const clearButton = priceDocumentElements.querySelectorAll(iconSearchClass);

            if (currencySelectParentList.length > 0) {
                
                const appdata = JSON.parse(sessionStorage.getItem('app') || '{}');
                
                let receiverCountry = appdata?.corridor?.receiverCountry?.isoCode ?? '';

                if(appdata) {
                    let sendAmountLimit = appdata?.senderAmountLimit;
                    document.querySelector('.sender-amount').setAttribute('data-send-up-to-amount-limit',sendAmountLimit);
                }

                let defaultReceiverCountry = 'MX'; 
                let transactionHistory = JSON.parse(sessionStorage.getItem('transactionHistoryResp')) || JSON.parse(sessionStorage.getItem('recentTransactionHistoryResp'));
                
                if(receiverCountry){
                    defaultReceiverCountry = receiverCountry;
                }else if(transactionHistory && transactionHistory.length > 0){
                    defaultReceiverCountry = transactionHistory[0]?.paymentDetails?.destination?.countryIsoCode;
                }
                
                currencySelectParentList.forEach((currencyelementID) => {

                    const sendAmountInput = currencyelementID.querySelector('.sender-amount');
                    const senderDiv = currencyelementID?.querySelector('.wu-input--currency-converter__box');
                    const sendUptoContainer = currencyelementID?.querySelector('.send-up-to-container');
                    const amtLimitError = currencyelementID?.querySelector('.amountlimit-error');
                    let receiverCountryCode = currencyelementID.getAttribute('data-reciver-country-code');
                    let isCorridor = (receiverCountryCode) ? true : false;
                    receiverCountryCode = (receiverCountryCode) ? receiverCountryCode : defaultReceiverCountry;

                
                    const joinNowCTA = currencyelementID.querySelector('.receiver_join_now_cta');
                    joinNowCTA.setAttribute('data-home-page-experience',homePageExperience) 

                    const language = currencyelementID.getAttribute('data-language');
                    const reqPayload = {
                        currency: currencyelementID.getAttribute('data-currency'),
                        country: currencyelementID.getAttribute('data-country'),
                        funds_in: currencyelementID.getAttribute('data-fund-in'),
                        fund_out_mnem: currencyelementID.getAttribute('data-fund-out-mnem'),
                        host: currencyelementID.getAttribute('data-host'),
                        sendAmount: sendAmountInput.dataset.value,
                    }

                    const joinBaseUrl = `/${reqPayload.country.toLowerCase()}/${language.toLowerCase()}/web`;
                    const joinNowlink = (joinNowCTA?.getAttribute('data-navigate-to-link') === '1') ? joinNowCTA?.getAttribute('href') :(`${joinBaseUrl}/${(isUserLogin || (homePageExperience === 'smo')) ? 'send-money/start' : 'user/register'}`);
                    joinNowCTA?.setAttribute('href', `${joinNowlink}`);    
                    if (receiverCountryCode) {
                        reqPayload.sendToCountry = receiverCountryCode;            
                        let reciverCountryObj = countryCurrencyDefaults.countries.find(c => c.country.isoCode.toLowerCase() === receiverCountryCode.toLowerCase());
                        let recivercurrencyCode = reciverCountryObj.country.currencies.find(currency=>currency);
                        reqPayload.sendToCurrency = getCurrencyFromPriceCorridor(receiverCountryCode) || recivercurrencyCode.currency;         
                        showFXrate(reqPayload, joinNowlink, isCorridor,priceDocumentElements,currencyelementID,true); 
                    } 

                    sendAmountInput?.tagName?.toUpperCase() === 'INPUT' && blockMinusSign(sendAmountInput);

                    sendAmountInput && sendAmountInput.addEventListener('blur', e => {
                        let sendamount = e.target.value.replace(/^\s+|\s+$/g, '');                    
                        if( (e.target.value != '') && (!sendamount.match(/^$/) )){
                            e.target.value = parseFloat(sendamount).toFixed(2);
                            sendAmountInput.value = e.target.value;
                        }   
                        const amountLimit = sendAmountInput.getAttribute('data-send-up-to-amount-limit');         
                        const sendUpto = amtLimitError.getAttribute('data-send-upto');         
                        if(parseFloat(sendamount) < 0){
                            senderDiv?.classList.add('wu-input--error');
                            clearReceiverAmount(currencyelementID, reqPayload.currency);
                        } else if(parseFloat(sendamount) > parseFloat(amountLimit)){
                            sendUptoContainer.classList.remove('d-none');
                            senderDiv?.classList.add('wu-input--error');
                            amtLimitError.innerText = `${sendUpto} ${amountLimit} ${reqPayload.currency}`;
                        } else {
                            sendUptoContainer.classList.add('d-none');
                            senderDiv?.classList.remove('wu-input--error');                  
                        }                
                    });

                    sendAmountInput && sendAmountInput.addEventListener('input', e => {
                        const maxLength = sendAmountInput.getAttribute('maxLength');
                        const value = Math.floor(e.target.value)  
                        if(value?.length > maxLength){
                            value = value.slice(0, maxLength);
                        }
                    });                    

                    sendAmountInput && sendAmountInput.addEventListener('input', debounceGeneric(e => {
                        let sendamount = e.target.value.replace(/^\s+|\s+$/g, '');
                        if (+sendamount < 0) {
                            sendUptoContainer.classList.add('d-none');
                            senderDiv?.classList.add('wu-input--error');
                            clearReceiverAmount(currencyelementID, reqPayload.currency);
                            return;
                        }
                        // Avoid API call for '', '0', '00', etc
                        if (!(+sendamount)) {
                            senderDiv?.classList.remove('wu-input--error');
                            document.querySelector('.send-up-to-container').classList.add('d-none');
                            sendAmountInput.dataset.value = e.target.value;
                            reqPayload.sendAmount = sendAmountInput.value;
                            clearReceiverAmount(currencyelementID, reqPayload.currency);
                            return;
                        }
                        const amountLimit = sendAmountInput.getAttribute('data-send-up-to-amount-limit');
                        const sendUpto = amtLimitError.getAttribute('data-send-upto');
                        if(parseFloat(sendamount) > parseFloat(amountLimit)){
                            sendUptoContainer.classList.remove('d-none');
                            senderDiv?.classList.add('wu-input--error');
                            amtLimitError.innerText = `${sendUpto} ${amountLimit} ${reqPayload.currency}`;
                        } else {
                            sendUptoContainer.classList.add('d-none');
                            senderDiv?.classList.remove('wu-input--error');                  
                        }
                        sendAmountInput.dataset.value = e.target.value;
                        reqPayload.sendAmount = sendAmountInput.value; 
                        showFXrate(reqPayload, joinNowlink, false,priceDocumentElements,currencyelementID,true); 
                    }, 500));

                    currencyelementID.querySelector('#dropdownmenu').addEventListener('click', function (event) {    
                        reqPayload.sendToCurrency = event.target.getAttribute("data-currencycode") || event.target.parentElement.getAttribute('data-currencycode');
                        reqPayload.sendToCountry = event.target.getAttribute("data-countrycode") || event.target.parentElement.getAttribute('data-countrycode');
                        sendAmountInput.dataset.value = (sendAmountInput.dataset.value > 0)? sendAmountInput.dataset.value : 1;
                        sendAmountInput.value = parseFloat(sendAmountInput.dataset.value).toFixed(2)
                        sessionStorage.removeItem(`getLimitsApiResponse-${reqPayload?.sendToCountry?.toUpperCase()}`);
                        sessionStorage.removeItem('sendAmountLimit');
                        currencyelementID.querySelector('.sender-amount')?.removeAttribute('data-send-up-to-amount-limit')
                        reqPayload.sendAmount = sendAmountInput.dataset.value;
                        showFXrate(reqPayload, joinNowlink, false,priceDocumentElements,currencyelementID,true);
                        clearSearch(event,liclass);
                    }); 
                });

                if(searchInput && searchInput.length > 0){
                    searchInput.forEach((searchInputElementID) => {
                        searchInputElementID.addEventListener('keyup', function(e){
                            if(e.target){                            
                                //do something
                                searchFilter(e,liclass,iconSearchClass); 
                            }                       
                        });
                    });
                }
        
                if(clearButton && clearButton.length > 0){
                    clearButton.forEach((clearButtonElementID) => {
                        clearButtonElementID.addEventListener('click', function(e){
                            if(e.target){                            
                                //do something
                              clearSearch(e,liclass);
                            }                       
                        });    
                    });
                }       
                
            }

            function clearReceiverAmount(currencyelementID, currency) {
                const receiverAmountEl = currencyelementID.querySelector('.receiver-Currency-Amount');
                if (receiverAmountEl) receiverAmountEl.value = '00.00';
                const totalEl = currencyelementID.querySelector('.amount-container .value');
                if (totalEl) totalEl.innerText = `00.00 ${currency}`;
            }

            // Join-now uses a span for the amount, which has no value to validate.
            function isNotPositiveInput(el) {
                return typeof el?.value === 'string' && !(parseFloat(el.value) > 0);
            }

            function blockMinusSign(input) {
                input.addEventListener('keydown', e => {
                    if (['-', '+', 'e', 'E'].includes(e.key)) e.preventDefault();
                    // Native stepping changes the amount unexpectedly.
                    if (['ArrowUp', 'ArrowDown'].includes(e.key)) e.preventDefault();
                });
                // Covers paste, drag-drop, autofill and mobile keyboards, which skip keydown.
                input.addEventListener('input', () => {
                    if (/[-+eE]/.test(input.value)) input.value = input.value.replace(/[-+eE]/g, '');
                });
            }

            async function showFXrate(reqPayload, joinNowlink, isCorridorPage, priceVariant,currencyelementID,receiverChange=false) {

                // Negative amounts are invalid; the price API rejects them.
                if (parseFloat(reqPayload.sendAmount) < 0) {
                    clearReceiverAmount(currencyelementID, reqPayload.currency);
                    return;
                }

                reqPayload.sendToCurrency =  setCountryCurrencyChange(reqPayload.sendToCountry,reqPayload.sendToCurrency);
                const reciverCountryCode = reqPayload.sendToCountry;
                const reciverCountryCurrency = reqPayload.sendToCurrency

                reqPayload.sendToCurrency =  setCountryCurrencyChange(reciverCountryCode,reciverCountryCurrency);

                 // Get limit and check before calling triggerPriceCatalog
                const amountLimitRaw = currencyelementID.querySelector('.sender-amount')?.getAttribute('data-send-up-to-amount-limit');
                const amountLimit = (amountLimitRaw === undefined || amountLimitRaw === null || amountLimitRaw === '') ? null : amountLimitRaw;
                const sendAmount = parseFloat(reqPayload.sendAmount);
                const originationIsoCode = {currency: reqPayload.currency,country: reqPayload.country};
                const destinationIsoCode= {currency:  reciverCountryCurrency,country:  reqPayload.sendToCountry};
                const limitAttribute = currencyelementID.querySelector('.sender-amount');
                const language = currencyelementID.getAttribute('data-language');
                const totalAmountEl = currencyelementID.querySelector('.amount-container .value');
                
                // If amountLimit is null, empty, or not a number, call getlimitAPI
                await CallGetLimitApi({amountLimit, originationIsoCode, fundsOutCode: reqPayload.fund_out_mnem, payIn: reqPayload.funds_in, destinationIsoCode, limitAttribute, country: reqPayload.country, language})
                

                // The user may have changed the amount to zero, empty or negative while the limit API was pending.
                if (isNotPositiveInput(limitAttribute)) {
                    return;
                }

                let sendAmountLimit = sessionStorage.getItem('sendAmountLimit');
                // Only call triggerPriceCatalog if sendAmount is within limit
                if (!sendAmountLimit || (sendAmountLimit && sendAmount <= parseFloat(sendAmountLimit))) {
                    const priceCatalogConfig = triggerPriceCatalog(reqPayload,true,true);
                    const wu_device_id = CookieService.getCookie('wu_device_id');
                    const headersCatalogApi = {
                        'Cookie': 'userIdentity=' + userIdentity + '; wu_device_id=' + wu_device_id
                    }

                    dataCatalogProduct(
                        false,
                        window.pageData.country,
                        window.pageData.language,
                        {
                            country: window.pageData.country,
                            sendToCountry: reciverCountryCode,
                            language: window.pageData.language,
                            sendAmount: reqPayload.sendAmount,
                            fund_in: currencyelementID.getAttribute('data-fund-in'),
                            fund_out_mnem: currencyelementID.getAttribute('data-fund-out-mnem'),
                            channel: currencySelectParentList?.[0]?.getAttribute("data-channel"),
                            client: currencySelectParentList?.[0]?.getAttribute("data-client")
                        },
                        priceCatalogConfig,
                        true,
                        reciverCountryCurrency
                    )
                        .then(async (response) => {
                        // Drop a quote that returns after the amount became zero, empty or negative.
                        if (isNotPositiveInput(limitAttribute)) {
                            return;
                        }
                        let {
                            fx = response.fx,
                            selectedFundsOut,
                            strike_fx_rate = response.strike_fx_rate,
                            selectedFundsIn,
                            strike_fee = (response.strike_fee === undefined || response.strike_fee === null) ? 0 : response.strike_fee,
                            fee,
                            receiveAmount,
                            strikeReceiveAmount,
                            payIn,
                            serviceCode,
                            fee_percentage = (response.fee_percentage === 0) ? 100 : response.fee_percentage,
                            gross_amount = response.gross_amount
                        } = isR4Country ? response : priceCatalogConfig.initApi(response)
                        
                        window.pageCalAtrributes = {senderCurrency,reciverCountryCurrency,fx,fee,selectedFundsOut,selectedFundsIn,receiveAmount}
                        if(strike_fee === null) {
                            strike_fee = 0
                        }
                        let fxOpposite
                        if(fx) {
                            fxOpposite = 1.00/fx;
                            fxOpposite = fxOpposite?.toFixed(4);

                        }
                        fx= fx?.toFixed(4);
                        strike_fx_rate = strike_fx_rate?.toFixed(4);
                        const fxData = { fx_amt: fx, strike_fx_amt: strike_fx_rate, payIn:selectedFundsIn,payOut:selectedFundsOut };
                        const fxEvent = new CustomEvent('alertFxEvent', {
                            detail: fxData
                        });
                        document.dispatchEvent(fxEvent);

                        const receiverCurrencyFee = ((priceVariant === priceVariantAId) || (priceVariant === joinNowId)) ? document.querySelector('.receiver-Currency-Fee') : undefined ;
                        // Update Flags
                        const receiverFlag = currencyelementID.querySelector('.receiverCurrencyDrop .wu-flag');
                        const lastCountrySelect = receiverFlag.getAttribute("data-countrycode");
                        if (lastCountrySelect) {
                            currencyelementID.querySelector('.receiverCurrencyDrop .wu-flag').classList.remove(lastCountrySelect);                       
                        }  


                        if((priceVariant === priceVariantAId)  || (priceVariant === priceVariantCalcWidgetEL) || (priceVariant === priceVariantBId) || (priceVariant === seasonalPriceVariantBId)){
                            const diffFeeEl = currencyelementID.querySelector('.difference-fee');
                            const receiverStrikedEl = currencyelementID.querySelector('.receiver-Currency-Amount-linethrough');        
                            const extraMoneyEl = currencyelementID.querySelector('.extraMoney');
                            const strikeFxTo = currencyelementID.querySelector('.strike-fx-to');
                            const extraMoneyParent = currencyelementID.querySelector('#extraMoneyParent');
                            const differenceFeeParent = currencyelementID.querySelector('#differenceFeeParent');
                            const strikeFxToText = currencyelementID.querySelector('.strike-fx-to-text');
                            const feeContainer = currencyelementID.querySelector('.fee-container');
                            const feeElem = feeContainer.querySelector('.fee');
                            const feeElemText = feeElem.getAttribute('data-fee-text-inital'); 
                            const receiveAmountElem = currencyelementID.querySelector('.receiver-Currency-Amount');
                            const fxContainer = currencyelementID.querySelector('.fx-container');                  
                            const fxToElem = fxContainer.querySelector('.fx-to');   
                            const limitAttribute =  currencyelementID.querySelector('.sender-amount'); 
                            const feePercentageContainer = feeContainer.querySelectorAll('.fee-percentage')
                            // below two variables will be used for showing fx as 1PHP=0.084ARS where ARS is send from currency 
                            const fxOppositeEl = currencyelementID.querySelector('.fx-opposite');
                            const fxToCurrencyEl = fxOppositeEl?.querySelector('.fx-to-currency');
                            const fxFromCurrencyEl = fxOppositeEl?.querySelector('.fx-from-currency');
                            let strikeFeeEl,currentFeeEl,strikedFeeToText;
                            const strikeFxFromText = currencyelementID.querySelector('.strike-fx-from-text');
                            const feedifferenceInitValue = diffFeeEl && diffFeeEl.getAttribute('data-fee-difference');
                            if(diffFeeEl) diffFeeEl.innerText =  feedifferenceInitValue; 
                        
                            const extraMoneyInitValue = extraMoneyEl && extraMoneyEl.getAttribute('data-reciver-extra-money');                            
                            if((extraMoneyEl !== null) && (extraMoneyEl)) extraMoneyEl.innerText =  extraMoneyInitValue;                            
                            

                            renderStrikedFxAndFee(strike_fee, fee, strikeReceiveAmount, 
                                receiveAmount, strike_fx_rate, extraMoneyParent, differenceFeeParent, 
                                strikeFxToText, strikeFxTo, receiverStrikedEl, feeElem, receiveAmountElem, reqPayload.currency, 
                                reciverCountryCurrency, reqPayload.sendAmount, extraMoneyEl, diffFeeEl, feeElemText,strikeFeeEl,currentFeeEl,strikedFeeToText,strikeFxFromText, fx, fee_percentage, feePercentageContainer);
                            


                            let receiveAmountValue = receiveAmount ? parseFloat(receiveAmount).toFixed(2) : '00.00';
                            let strikedValue = strikeReceiveAmount ? parseFloat(strikeReceiveAmount).toFixed(2) : '00.00';

                            receiveAmountElem ? receiveAmountElem.value = receiveAmountValue : '';
                            receiverStrikedEl ? receiverStrikedEl.textContent = strikedValue : '';

                            if(typeof renderFxRate !== 'undefined' && renderFxRate.render !== 'undefined') {
                                renderFxRate.render(receiveAmountValue, strikedValue);
                            }
                            
                            const originationIsoCode = {currency: reqPayload.currency,country: reqPayload.country};
                            const destinationIsoCode= {currency:  reciverCountryCurrency,country:  reqPayload.sendToCountry};

                            if(receiverChange){
                                const language = currencyelementID.getAttribute('data-language');
                                // Remove cached limits before fetching new ones
                                // await CallGetLimitApi({amountLimit, originationIsoCode, fundsOutCode: reqPayload.fund_out_mnem, payIn: reqPayload.funds_in, destinationIsoCode, limitAttribute, country: reqPayload.country, language});
                                if(priceVariant === priceVariantAId){
                                    const receiverCurrencyFlag = document.querySelector('.receiver-Currency-flag');
                                    receiverCurrencyFlag.classList.remove(lastCountrySelect);
                                    receiverCurrencyFlag.classList.add(reqPayload.sendToCountry.toLowerCase());
                                }
                                
                            }
                            
                            if(priceVariant === priceVariantAId){
                                const receiverActualFee = receiverCurrencyFee.getAttribute('data-receiver-Currency-fee');                   
                                if(fx === null && receiverActualFee > 0){
                                    receiverCurrencyFee.setAttribute('data-receiver-Currency-fee',receiverActualFee);
                                    fx = receiverActualFee;                       
                                } else {
                                    receiverCurrencyFee.setAttribute('data-receiver-Currency-fee',fx);
                                } 
                            }

                            if (fx) {
                                fxToElem.innerHTML = fx + ' ' + reciverCountryCurrency;
                            }

                            if(fxOppositeEl && fxToCurrencyEl && fxOpposite) {
                                fxToCurrencyEl.innerText = reciverCountryCurrency;
                                fxFromCurrencyEl.innerText = `${fxOpposite} ${senderCurrency.toUpperCase()}`;
                                fxOppositeEl.classList.remove('d-none');
                            } else {
                                fxOppositeEl?.classList.remove('d-none');
                            }

                            const hasFxToggle = fxContainer.hasAttribute('data-fx-toggle');
                            if (hasFxToggle) {
                                if(fx) {
                                    toggleClass(fxContainer, 'd-none', 'd-inline-flex');
                                    toggleClass(fxContainer, 'd-none', 'd-flex');
                                } else {
                                    toggleClass(fxContainer, 'd-inline-flex', 'd-none');
                                    toggleClass(fxContainer, 'd-flex', 'd-none');
                                }
                            }
        
                            if (receiveAmount !== strikeReceiveAmount) {                        
                                receiveAmountElem.classList.add('wu-input--is-focus');
                                strikeReceiveAmount && toggleClass(extraMoneyParent,'d-none' ,'d-flex' );
                            }else {
                                toggleClass(extraMoneyParent,'d-flex' ,'d-none' );
                                strikeFxToText?.classList.add('d-none')
                                strikeFxTo?.classList.add('d-none')
                                strikeFxFromText?.classList.add('d-none')
                                receiverStrikedEl?.classList.add('d-none')
                                receiverStrikedEl && receiveAmountElem?.classList.add('p-4')
                            } 
        
                            if(((fee === strike_fee) && (fee === 0) && (strike_fee === 0)) || ((fee === null) && (strike_fee === 0))){
                                toggleClass(feeContainer, 'd-flex', 'd-none');
                                toggleClass(feeContainer, 'd-inline-flex', 'd-none');
                                toggleClass(differenceFeeParent,'d-flex','d-none');
                                feeElem?.classList.add('d-none')
                                feeElem.innerText = feeElemText
                            } else if (strike_fee === undefined) {
                                toggleClass(differenceFeeParent,'d-flex','d-none');
                            }else{
                                toggleClass(feeContainer, 'd-none', 'd-flex');
                                toggleClass(feeContainer, 'd-none', 'd-inline-flex');
                                feeElem?.classList.remove('d-none');
                            }
                            const descriptionDisplay = document.querySelector('.description-display');
                            if((fee > 0) && (descriptionDisplay) && (descriptionDisplay !== null)){                                
                                descriptionDisplay.classList.add('d-none');
                            } else if((fee === 0) && (descriptionDisplay) && (descriptionDisplay !== null)){
                                descriptionDisplay.classList.remove('d-none');
                            }

                        } else {

                            let fxrateNumber = fx;
                            let fxratefloor = Math.floor(fxrateNumber);
                            let fxrate = (fxratefloor === fxrateNumber) ? fxrateNumber.toFixed(2) : fxrateNumber;
                            receiverCurrencyFee ? receiverCurrencyFee.textContent = fxrate : '00.00';

                            const receiverCurrencyFeelinethrough = document.querySelector('.receiver-Currency-Fee-linethrough');
                            let StrikefxrateNumber = strike_fx_rate;
                            let Strikefxratefloor = Math.floor(StrikefxrateNumber);
                            let Strikefxrate = (Strikefxratefloor === StrikefxrateNumber) ? StrikefxrateNumber.toFixed(2) : StrikefxrateNumber;
                            receiverCurrencyFeelinethrough ? receiverCurrencyFeelinethrough.textContent = Strikefxrate : '00.00';

                            const receiverCurrencylinethrough = document.getElementById('default-receiver-currency-linethrough');
                            receiverCurrencylinethrough ? receiverCurrencylinethrough.textContent = reciverCountryCurrency : undefined;

                            if ((fxrateNumber !== StrikefxrateNumber) && joinNowId) {
                                receiverCurrencyFeelinethrough.classList.remove('d-none');
                                receiverCurrencylinethrough.classList.remove('d-none');
                            } else if ((fxrateNumber === StrikefxrateNumber) && joinNowId){
                                receiverCurrencyFeelinethrough.classList.add('d-none');
                                receiverCurrencylinethrough.classList.add('d-none'); 
                            }
                        }
                    
                    
                        if (receiverFlag) {
                            receiverFlag.classList.add(reqPayload.sendToCountry.toLowerCase());
                            receiverFlag.setAttribute('data-countrycode', reqPayload.sendToCountry.toLowerCase());                        
                        }
                        
                        if (!isCorridorPage && joinNowId) {
                            currencyelementID.querySelector('.receiverCurrencyDrop .wu-icon-default-global').classList.add('d-none');
                        }

                        if(totalAmountEl && limitAttribute) {
                            const totAmt = parseFloat(gross_amount).toFixed(2);
                            totalAmountEl.innerText = (gross_amount !== undefined) ? `${totAmt} ${reqPayload.currency}` : `${limitAttribute.value} ${reqPayload.currency}`;
                        }

                        currencyelementID.querySelector('.receiverCurrencyDrop .wu-flag').classList.remove('d-none');

                        const receiverCurrency = currencyelementID.querySelector('#default-receiver-currency-code');
                        receiverCurrency && (receiverCurrency.textContent = reciverCountryCurrency);

                        const receiverJoinnowCurrencies = document.querySelectorAll('.receiver_join_now_cta');                    
                        CookieService.setCookie("lastCountry", reqPayload.sendToCountry, 365);
                        CookieService.setCookie("lastCurrency", reciverCountryCurrency, 365);
                        CookieService.setCookie("lastSendAmount",reqPayload.sendAmount, 30);   
                        CookieService.setCookie("lastFundsIn", (CloudPayIn[selectedFundsIn] || selectedFundsIn), 365);
                        CookieService.setCookie("lastFundsOut", CloudPayOut[selectedFundsOut], 365);                        

                        
                        const fundsOut = isUserLogin ? CloudPayOut[selectedFundsOut] : selectedFundsOut;
                        const fundsIn = isUserLogin ? (CloudPayIn[selectedFundsIn] || selectedFundsIn) : selectedFundsIn;
                        const queryParams = `?ReceiveCountry=${reqPayload.sendToCountry}&ISOCurrency=${reqPayload.sendToCurrency}&SendAmount=${reqPayload.sendAmount}&${isUserLogin ? `FundsOut=${fundsOut}&FundsIn=${fundsIn}` : `funds-out=${selectedFundsOut}&funds-in=${selectedFundsIn}`}`
                        const join_now_link = `${joinNowlink}${queryParams}`;
                        setNavSendMoneyParams(queryParams)
                        window.receiverCountry = reqPayload.sendToCountry
                        Array.from(receiverJoinnowCurrencies)?.forEach(receiverJoinnowCurrency => {
                            receiverJoinnowCurrency.setAttribute('href', `${join_now_link}`);
                        });

                    }).catch((err) => {
                        console.error(err);
                    });
                } else if(sendAmountLimit && sendAmount > parseFloat(sendAmountLimit)) {
                    // The limit can arrive after the input handler ran, so show the error here too.
                    const limitErrorEl = currencyelementID.querySelector('.amountlimit-error');
                    currencyelementID.querySelector('.wu-input--currency-converter__box')?.classList.add('wu-input--error');
                    currencyelementID.querySelector('.send-up-to-container')?.classList.remove('d-none');
                    if (limitErrorEl) limitErrorEl.innerText = `${limitErrorEl.getAttribute('data-send-upto')} ${sendAmountLimit} ${reqPayload.currency}`;
                    currencyelementID.querySelector('.receiver-Currency-Amount').value =`00.00`;
                    if(totalAmountEl)
                        totalAmountEl.innerText = `00.00 ${reqPayload.currency}`;
                    currencyelementID.querySelector('.strike-fx-to-text')?.classList.add('d-none');
                    currencyelementID.querySelector('.strike-fx-to')?.classList.add('d-none');
                    
                    toggleClass(currencyelementID.querySelector('.fee-container'), 'd-flex', 'd-none');
                    toggleClass(currencyelementID.querySelector('.fee-container'), 'd-inline-flex', 'd-none');
                    
                }
                window.isInitialCatalogCalled = true;
        }

            
        } // End Main If
    })
    }  

    let usrIdentity = CookieService.getCookie('userIdentity');
    
    let qs = new URLSearchParams(window.location.search);
    let isOptlyPreview = qs.has('optimizely_token');

    usrIdentity === 'existingCustomer' && !isOptlyPreview && priceVariantBId && manageUSHomeExperience(priceVariantBId, priceVariantCalcWidgetEL, priceBenefits, summaryBenefitsCalc);
    
    if(joinNowElements.length > 0) {       
        homePriceComponent({variation :'joinnow'});
    } 
    if(priceVariantBElements.length > 0 || seasonalPriceVariantBElements) {
        homePriceComponent({variation: "priceVariantB"});
    } 
    if(calcWidgetElements && calcWidgetElements.length > 0) {
        homePriceComponent({variation: "summaryCalculator"});   
    }     
};

(() => {    
    try {
        priceComponent({})
    } catch(e) {
      // Error handled silently for security
    }    
})()